import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import MenuIcon from "../assets/MenuIcon";

import Modal from "./Modal";
import Wallet from "./Wallet";

const Header = ({ openSidebar, setOpenSidebar }) => {
  const [list, setList] = useState([
    { lbl: "Comprar", slug: "/comprar" },
    { lbl: "Vender", slug: "/vender" },
    { lbl: "Quienes somos", slug: "/quienes" },
    { lbl: "Marketplace", slug: "/marketplace" },
    { lbl: "Club", slug: "/club" },
    { lbl: "FAQs", slug: "/faqs" },
    { lbl: "Contacto", slug: "/contacto" },
  ]);
  const [open, setOpen] = useState(false);

  return (
    <div className="header-camp flex">
      <div className="wrapWidth wrap flex aic">
        <div className="flex flex-col w-full">
          <div className="action flex aic justify-end">
            <div
              className="btn-connect flex aic cursor-pointer"
              onClick={(e) => setOpen(!open)}
            >
              <div className="btn-lbl button">Conectar con Wallet</div>
              <div className="icon">
                <img src="./images/Wallet.png" className="btn-img" />
              </div>
            </div>
          </div>
          <div className="min-hdr flex aic">
            <div className="left flex aic">
              <Link to="/">
                <img src="./images/logo.svg" className="logo-img" />
              </Link>
              <input
                type="text"
                placeholder="buscar NFT Art"
                className="btn-art"
              />
            </div>
            <div className="right flex aic">
              <div className="items flex aic">
                {list.map((item, index) => (
                  <NavLink to={item.slug} className="item">
                    {item.lbl}
                  </NavLink>
                ))}
              </div>
              <div
                className="menu-icon flex items-center justify-center"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenSidebar(true);
                }}
              >
                <MenuIcon />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Wallet />
      </Modal>
    </div>
  );
};

export default Header;
